import React, { useState, useRef, useEffect } from 'react';
import { C } from '../utils/theme.js';
import { t } from '../utils/i18n.js';
import RadioBot from './RadioBot.jsx';

export default function Heraldo(props) {
  var lang = props.lang;
  var authToken = props.authToken;
  var authUser = props.authUser;
  var stats = props.stats;
  var myGrid = props.myGrid;

  var _open = useState(false); var open = _open[0]; var setOpen = _open[1];
  var _input = useState(""); var input = _input[0]; var setInput = _input[1];
  var _msgs = useState([]); var msgs = _msgs[0]; var setMsgs = _msgs[1];
  var _loading = useState(false); var loading = _loading[0]; var setLoading = _loading[1];
  var scrollRef = useRef(null);
  var inputRef = useRef(null);

  // Auto-scroll to bottom
  useEffect(function() {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [msgs, loading]);

  // Focus input when opened
  useEffect(function() {
    if (open && inputRef.current) inputRef.current.focus();
  }, [open]);

  // Listen for external open requests (e.g. from Home card)
  useEffect(function() {
    function onHeraldoOpen(e) {
      var msg = e.detail && e.detail.message;
      handleOpen();
      if (msg) {
        setTimeout(function() { sendMessage(msg); }, 500);
      }
    }
    window.addEventListener("heraldo-open", onHeraldoOpen);
    return function() { window.removeEventListener("heraldo-open", onHeraldoOpen); };
  }, [authToken, msgs]);

  // Welcome message on first open
  function handleOpen() {
    setOpen(true);
    if (msgs.length === 0) {
      var call = authUser ? authUser.callsign : "OM";
      var welcome = lang === "pt"
        ? "Ola " + call + "! \u{1F4E1} Sou o Heraldo, seu assistente de radio. Me pergunte sobre propagacao, antenas, DX, ou qualquer coisa sobre radioamadorismo!"
        : "Hello " + call + "! \u{1F4E1} I'm Heraldo, your radio assistant. Ask me about propagation, antennas, DX, or anything about ham radio!";
      setMsgs([{ role: "assistant", content: welcome }]);
    }
  }

  function sendMessage(text) {
    if (!text || !text.trim() || loading || !authToken) return;
    var msg = text.trim();
    setInput("");

    var newMsgs = msgs.concat([{ role: "user", content: msg }]);
    setMsgs(newMsgs);
    setLoading(true);

    // Build rich context from stats
    var context = {};
    if (stats) {
      context.total = stats.total;
      context.uniqueCountries = stats.uniqueCountries;
      context.uniqueGrids = stats.uniqueGrids;
      context.bestBand = stats.bestBand;
      context.bestBandQsos = stats.bestBandQsos;
      context.bestHour = stats.bestHour;
      context.maxDist = stats.maxDist;
      context.avgDist = stats.avgDist;
      context.myGrid = myGrid;
      context.topBandDay = stats.topBandDay;
      context.topBandDayQsos = stats.topBandDayQsos;
      context.topBandNight = stats.topBandNight;
      context.topBandNightQsos = stats.topBandNightQsos;
      context.tzStr = stats.tzStr;
      context.logDays = stats.logDays;
      context.dxccWorked = stats.dxccWorkedCount;
      context.dxccConfirmed = stats.dxccLotwConfirmedCount;
      if (stats.byBand) context.byBand = stats.byBand.slice(0, 8).map(function(b) { return b[0] + ":" + b[1]; }).join(", ");
      if (stats.byMode) context.byMode = stats.byMode.slice(0, 5).map(function(m) { return m[0] + ":" + m[1]; }).join(", ");
      if (stats.byCont) context.byCont = stats.byCont.filter(function(c) { return c[0] !== "??"; }).map(function(c) { return c[0] + ":" + c[1]; }).join(", ");
    }

    // Build history (exclude welcome, send last 10 exchanges)
    var history = [];
    for (var i = 0; i < newMsgs.length; i++) {
      history.push({ role: newMsgs[i].role, content: newMsgs[i].content });
    }

    fetch("/api/heraldo/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + authToken },
      body: JSON.stringify({ message: msg, history: history.slice(0, -1), context: context, lang: lang })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        setLoading(false);
        if (data.error) {
          setMsgs(function(prev) { return prev.concat([{ role: "assistant", content: "\u26A0\uFE0F " + data.error }]); });
        } else {
          setMsgs(function(prev) { return prev.concat([{ role: "assistant", content: data.reply }]); });
        }
      })
      .catch(function() {
        setLoading(false);
        setMsgs(function(prev) { return prev.concat([{ role: "assistant", content: "\u26A0\uFE0F " + t(lang, "heraldoError") }]); });
      });
  }

  var suggestions = lang === "pt"
    ? ["Qual a melhor banda agora?", "Me ajude com DXCC", "Dica de antena", "Como funciona FT8?"]
    : ["Best band right now?", "Help me with DXCC", "Antenna tips", "How does FT8 work?"];

  // Floating button (always visible)
  if (!open) {
    return (
      <div className="heraldo-fab-outer" style={{ position: "fixed", bottom: 22, right: 22, zIndex: 99999 }}>
        <div onClick={handleOpen} className="heraldo-fab-inner" style={{
          width: 74, height: 74, borderRadius: "50%",
          background: "linear-gradient(135deg, #1e3a5f, #3b82f6)",
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", border: "2px solid #00d4ff40"
        }}>
          <RadioBot size={44} />
        </div>
      </div>
    );
  }

  // Chat panel
  return (
    <div style={{
      position: "fixed", bottom: 20, right: 20, zIndex: 99999,
      width: 370, height: 520, borderRadius: 16,
      background: C.s1, border: "1px solid " + C.bd,
      display: "flex", flexDirection: "column",
      boxShadow: "0 8px 40px rgba(0,0,0,0.6)",
      overflow: "hidden"
    }}>
      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
        padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between",
        flexShrink: 0
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <RadioBot size={30} />
          <div>
            <div style={{ fontWeight: 700, fontSize: 14, color: "#fff" }}>Heraldo</div>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,0.7)" }}>AI Ham Radio Assistant</div>
          </div>
        </div>
        <button onClick={function() { setOpen(false); }} style={{
          background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%",
          width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", color: "#fff", fontSize: 14, fontWeight: 700
        }}>{"\u2715"}</button>
      </div>

      {/* Messages */}
      <div ref={scrollRef} style={{
        flex: 1, overflowY: "auto", padding: "12px 12px 8px",
        display: "flex", flexDirection: "column", gap: 8,
        scrollbarWidth: "thin"
      }}>
        {msgs.map(function(m, i) {
          var isUser = m.role === "user";
          return (
            <div key={i} style={{
              alignSelf: isUser ? "flex-end" : "flex-start",
              maxWidth: "85%"
            }}>
              <div style={{
                background: isUser ? "#3b82f6" : C.s2,
                color: isUser ? "#fff" : C.t1,
                borderRadius: isUser ? "14px 14px 4px 14px" : "14px 14px 14px 4px",
                padding: "8px 12px",
                fontSize: 13, lineHeight: 1.5,
                border: isUser ? "none" : "1px solid " + C.bd
              }}>{m.content}</div>
            </div>
          );
        })}
        {loading && (
          <div style={{ alignSelf: "flex-start", maxWidth: "85%" }}>
            <div style={{
              background: C.s2, borderRadius: "14px 14px 14px 4px",
              padding: "10px 16px", border: "1px solid " + C.bd,
              display: "flex", gap: 4
            }}>
              {[0, 1, 2].map(function(d) {
                return <div key={d} style={{
                  width: 7, height: 7, borderRadius: "50%", background: C.a1,
                  animation: "heraldoPulse 1.4s ease-in-out " + (d * 0.2) + "s infinite"
                }}></div>;
              })}
              <style>{"@keyframes heraldoPulse{0%,80%,100%{opacity:0.3;transform:scale(0.8)}40%{opacity:1;transform:scale(1.1)}}"}</style>
            </div>
          </div>
        )}
      </div>

      {/* Suggestions (only show when few messages) */}
      {msgs.length <= 2 && !loading && (
        <div style={{ padding: "0 12px 8px", display: "flex", gap: 4, flexWrap: "wrap" }}>
          {suggestions.map(function(s, i) {
            return (
              <button key={i} onClick={function() { sendMessage(s); }} style={{
                background: C.s2, border: "1px solid " + C.bd, borderRadius: 12,
                padding: "4px 10px", fontSize: 11, color: C.a1,
                cursor: "pointer", whiteSpace: "nowrap"
              }}>{s}</button>
            );
          })}
        </div>
      )}

      {/* Input */}
      <div style={{
        padding: "8px 12px 12px", display: "flex", gap: 8,
        borderTop: "1px solid " + C.bd, flexShrink: 0
      }}>
        <input
          ref={inputRef}
          value={input}
          onChange={function(e) { setInput(e.target.value); }}
          onKeyDown={function(e) { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(input); } }}
          placeholder={t(lang, "heraldoPlaceholder")}
          disabled={loading}
          style={{
            flex: 1, background: C.s2, border: "1px solid " + C.bd, borderRadius: 10,
            padding: "8px 12px", color: C.t1, fontSize: 13, outline: "none",
            fontFamily: "inherit"
          }}
        />
        <button
          onClick={function() { sendMessage(input); }}
          disabled={loading || !input.trim()}
          style={{
            background: loading || !input.trim() ? C.s3 : "linear-gradient(135deg, #3b82f6, #8b5cf6)",
            border: "none", borderRadius: 10, width: 40, height: 38,
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: loading || !input.trim() ? "default" : "pointer",
            fontSize: 16, color: "#fff"
          }}
        >{"\u{1F4E8}"}</button>
      </div>
    </div>
  );
}
